/**
 * 
 * WARNING:
 * This file was automatically generated as the output of a build process.
 * If you make changes to it directly via Shopify's Code Editor, your changes
 * will be overwritten the next time a build runs.
 * 
 * If you need to make changes to the source file, request Github Access
 * from the project lead, and follow the process steps in the README file.
 * 
 */

document.addEventListener("alpine:init",(()=>{Alpine.data("recommendations",(()=>({async getProducts(e){await function({url:e,parse:t,update:r=null}){if(0!==e.length&&0!==t.length)return fetch(e).then((e=>{if(!e.ok){const t=new Error(e.status);throw console.error("Error:",t),t}return e.text()})).then((e=>{const n=(new DOMParser).parseFromString(e,"text/html").querySelector(t).innerHTML;return null!==r&&document.querySelectorAll(r).forEach((e=>{e.innerHTML=n})),n})).catch((e=>{throw e}));console.error("Provide both a URL to fetch and DOM selector within return data to parse.")}({url:e,parse:"[data-product-recommendations]",update:"[data-product-recommendations]"})}})))}));
